import React, { useMemo } from 'react';
import { NavLink } from 'react-router-dom';

import RatingStarsWidget from 'components/RatingStarsWidget';
import RatingPanel from 'components/RatingPanel';
import MediaQuery from 'react-responsive';
import RatingStarsWidgetMinimal from 'components/RatingStarsWidgetMinimal';
import LinkBuilder from 'helpers/link-builder';
import { DateHelpers } from 'helpers/date-helpers';

const TypeFirmRating = props => {
  const {
    post: {
      Source,
      SourceFullName,
      FirmID,
      FirmName,
      FirmUrlAlias,
      FirmActive,
      FirmIDC,
      FirmNameC,
      FirmUrlAliasC,
      FirmActiveC,
      CandidateRating,
      NewsFeedDateAdd,
      PostRatingVal,
      Date,
    },
    actions: { handleBeforeFirmRatingUpdate, handleFirmRatingUpdate },
  } = props;

  const onReviewRatingUpdate = mark => {
    handleFirmRatingUpdate(FirmID, mark);
  };

  const onBeforeReviewRatingUpdate = () => handleBeforeFirmRatingUpdate();

  let fromName = null;
  if (Source) {
    fromName = <span className="feed-post__anonym-name">{SourceFullName}</span>;
  } else if (FirmNameC) {
    if (FirmIDC && FirmActiveC === 'Yes') {
      fromName = (
        <NavLink to={LinkBuilder.getFirmLink(FirmUrlAliasC)}>
          {FirmNameC}
        </NavLink>
      );
    } else {
      fromName = <span className="feed-post-content__span">{FirmNameC}</span>;
    }
  }

  const ratingValue = parseInt(PostRatingVal);

  const firmLink =
    FirmUrlAlias && FirmActive === 'Yes' ? (
      <NavLink
        className="feed-post-content__hero"
        to={LinkBuilder.getFirmLink(FirmUrlAlias)}
      >
        {FirmName}
      </NavLink>
    ) : (
      <span className="feed-post-content__hero--span">{FirmName}</span>
    );

  const date = useMemo(() => {
    const [year] = DateHelpers.getDateArray(Date);
    const currentYear = DateHelpers.getCurrentYear();

    return currentYear > Number(year)
      ? DateHelpers.getMonthNameDayYearFormat(Date)
      : NewsFeedDateAdd;
  }, [Date, NewsFeedDateAdd]);

  return (
    <div className="feed-post-content__inner feed-post-content__inner--typed">
      <div className="feed-post-content__top">
        {firmLink}
        <div className="feed-post-content__text">
          received a{' '}
          <MediaQuery query="(max-width: 767px)">
            <RatingStarsWidgetMinimal ratingValue={ratingValue} size={14} />
            {fromName ? ' rating from' : ' rating'}
          </MediaQuery>
        </div>
        <MediaQuery query="(min-width: 768px)">
          {' '}
          <div className="feed-post-content__rating">
            <RatingStarsWidget value={parseInt(PostRatingVal)} size={18} />
          </div>
          <div className="feed-post-content__text">
            {fromName ? 'rating from' : 'rating'}
          </div>{' '}
        </MediaQuery>
        {fromName}
      </div>
      <div className="feed-post-content__date">{date}</div>
      <div className="feed-post-content__middle">
        {!CandidateRating && (
          <RatingPanel
            text={FirmName}
            onBeforeChangeRatingHandler={onBeforeReviewRatingUpdate}
            onChangeRatingHandler={onReviewRatingUpdate}
          />
        )}
      </div>
    </div>
  );
};

export default TypeFirmRating;
